module.exports = __webpack_public_path__ + "static/media/baby.c2a83f52.svg";